/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
import { useState, useEffect } from 'react';
import dateFormat from 'dateformat';
import { useLang } from '../../_metronic/i18n/Metronici18n';

const DateValue = (props: any) => {
    const { datas, handleClick } = props;
    const [value, setValue] = useState<string>("");
    const lang = useLang()

    useEffect(() => {
        if (datas) {
            try {
                if (lang === "en") {
                    const newvlaue = dateFormat(new Date(datas), "mm/dd/yyyy") 
                    setValue(newvlaue)
                } else {
                    const newvlaue = dateFormat(new Date(datas), "dd.mm.yyyy") 
                    setValue(newvlaue)
                }
            } catch (error) {
                
            }
        }
        // eslint-disable-next-line
    }, [datas])

    return (
        <td style={{ padding: '0px 10px' }}
            onClick={handleClick}
        >
            <a className='text-dark text-hover-primary d-block ' style={{ cursor: 'pointer', fontSize: '13px', fontWeight: 500, color: '#3F4254' }}>
                {value}
            </a>
        </td>
    )
}

export default DateValue;